<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="FMH"><span class="CT-Colour">Contents</span></p>
<p class="CC-TX"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="ePub-I">Title Page</span></span></p>
<p class="CC-TX"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample"><span class="ePub-I">Copyright Notice</span></span></p>
<p class="CC-TX1"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample"><span class="ePub-I">Dedication</span></span></p>
<p class="CC-TX"><span href="#/xhtml/introduction#intro" title="Link target outside of Sample"><span class="ePub-I">Introducing Isabel</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter1#ch1" title="Link target outside of Sample"><span class="ePub-I">The Locked Door</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter2#ch2" title="Link target outside of Sample"><span class="ePub-I">The Pirates</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample"><span class="ePub-I">The Race</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample"><span class="ePub-I">The Challenge</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample"><span class="ePub-I">Lucky Cricket</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample"><span class="ePub-I">Splash!</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample"><span class="ePub-I">Butterfly</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample"><span class="ePub-I">Found</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample"><span class="ePub-I">The Nightmare</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample"><span class="ePub-I">The Wave</span></span></p>
<p class="CC-TX"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample"><span class="ePub-I">Bearjitsu Bear</span></span></p>
<p class="CC-TX1"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample"><span class="ePub-I">The Rock</span></span></p>
<p class="CC-TX"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample"><span class="ePub-I">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6e98ac42